export default class Str
{
    static SAFE_URL_SCHEMES = ['http', 'https', 'mailto', 'tel'];

    static HTML_ESCAPES = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    static camelToKebab(string)
    {
        return string.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
    }

    /**
     * Escape a value for interpolation into HTML, safe for both text and quoted attributes.
     * Breaking out of an attribute needs only a quote -- no angle brackets -- so the quotes
     * matter as much as the brackets.
     */
    static escapeHtml(value)
    {
        return String(value ?? '').replace(/[&<>"']/g, (char) => Str.HTML_ESCAPES[char]);
    }

    /**
     * A URL safe to put in an href, or '' when its scheme could run script.
     *
     * Relative and protocol-relative URLs carry no scheme of their own and pass through. Control
     * characters are stripped before the scheme is read, because browsers ignore them when they
     * resolve one -- `java\tscript:` is javascript: to a browser.
     */
    static safeUrl(value)
    {
        const url    = String(value ?? '').replace(/[\u0000-\u001F\u007F]/g, '').trim();
        const scheme = url.match(/^([a-z][a-z0-9+.-]*):/i);

        if (!scheme) {
            return url;
        }

        return Str.SAFE_URL_SCHEMES.includes(scheme[1].toLowerCase()) ? url : '';
    }
}
